module.exports = "pegasus/assets/theme4/medium/3.jpg";